import { render, staticRenderFns } from "./chuzhan.vue?vue&type=template&id=3d1aa6be&scoped=true&"
import script from "./chuzhan.vue?vue&type=script&lang=js&"
export * from "./chuzhan.vue?vue&type=script&lang=js&"
import style0 from "./chuzhan.vue?vue&type=style&index=0&id=3d1aa6be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1aa6be",
  null
  
)

export default component.exports